import { z } from "zod";

export const postSendPushNotificationsRequestSchema = z.object({
  workerIds: z.string(),
  title: z.string().min(1),
  message: z.string().min(1),
});

export type TPostSendPushNotificationsRequest = z.infer<
  typeof postSendPushNotificationsRequestSchema
>;
